<!--component html goes here -->
<!-- Hero Start -->
<app-header></app-header>
<!-- <section class="bg-half-170 bg-light d-table w-100" id="home">
    <div class="container">
      <div class="row mt-5 justify-content-center">
        <div class="col-lg-12 text-center">
          <div class="pages-heading">
            <h2> Design your apps in your own way </h2>
            <ul class="list-unstyled mt-4 mb-0">
              <li class="list-inline-item h6 user text-muted me-2"><i class="mdi mdi-account"></i> Calvin Carlo</li>
              <li class="list-inline-item h6 date text-muted"><i class="mdi mdi-calendar-check"></i> 25th June 2021</li>
            </ul>
          </div>
        </div>
      </div>
  
      <div class="position-breadcrumb">
        <nav aria-label="breadcrumb" class="d-inline-block">
          <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
            <li class="breadcrumb-item"><a routerLink="/index">Landrick</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)">Page</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0)">Blog</a></li>
            <li class="breadcrumb-item active" aria-current="page">Blog Detail</li>
          </ul>
        </nav>
      </div>
    </div> 
  </section> -->
  <!-- Hero End -->
  
  <!-- Shape Start -->
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!--Shape End-->
  
  <!-- Blog STart -->
  <section class="section" *ngIf="mainVideo && mainVideo.id>0">
    <div class="container">
      <div class="row">
        <!-- BLog Start -->

        <div class="col-lg-8 col-md-6">
          <div class="card blog blog-detail border-0 shadow rounded">
            <!-- <iframe [src]="photoURL(mainVideo.videoUrl)"
             allowfullscreen=""
              allow="encrypted-media" 
              style="width: 100%;"
              class="videoCard"
              >
            </iframe> -->
            <video class="videoCard" width="100%" autoplay="autoplay" controls style="margin-top: 50px; margin-bottom: 20px;">
              <source [src]="mainVideo.videoUrl" type="video/mp4">
                </video>
            <!-- <img src="assets/images/blog/01.jpg" class="img-fluid rounded-top" alt=""> -->
            <div style="width: 100%;" class="videoCard"  [innerHtml]="mainVideo.embedServiceHtml">
<!--         

          <video   controls width="100%" id="video1" height="100%"  autoplay>
            <source src="{{mainVideo.videoUrl}}" type="video/webm" />
          
            <source src="{{mainVideo.videoUrl}}" type="video/mp4" />
          
          </video> -->
        </div>

            <div class="card-body content">
              <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                  <a class="pe-1" href="experiences-for-traveler/{{mainVideo.travelerId}}" style="margin: 0%;">
                    <img src="{{mainVideo.travelerImage?mainVideo.travelerImage:imageUrl}}" class="img-fluid avatar avatar-md-sm rounded-circle shadow"
                      alt="img">
                  </a>
                  <div class="commentor-detail" style="margin: 0%;">
                    <h6 class="mb-0"><a href="experiences-for-traveler/{{mainVideo.travelerId}}" class="text-dark media-heading">{{mainVideo.travelerName}}</a>
                    </h6>
                    <!-- <small class="text-muted">{{mainVideo.date|date:'dd/MM/yyyy hh:MM'}}</small> -->
                  </div>
                </div>
                <!-- <a [ngxScrollTo]="'#home'" class="text-muted"><i class="mdi mdi-reply"></i> Reply</a> -->
              </div>
              <h6><i class="mdi mdi-tag text-primary me-1"></i><a href="javscript:void(0)"
                  class="text-primary">{{mainVideo.title}}</a></h6>
              <p class="text-muted mt-3">{{mainVideo.description}}
             </p>
             <div class="post-meta mt-3">
                <ul class="list-unstyled mb-0">
                  <!-- <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i
                        class="uil uil-heart me-1"></i>{{mainVideo.numberOfStars}}</a></li> -->
                  <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                        class="uil uil-comment me-1"></i>{{mainVideo.comments.length}}</a></li>
                        <li class="list-inline-item float-right" >
                        <mat-star-rating [rating]="rating"  [starCount]="starCount" [color]="starColor" (ratingUpdated)="onRatingChanged($event)"></mat-star-rating>

                        </li>
                </ul>

              </div>
            </div>
          </div>
  
          <div class="card shadow rounded border-0 mt-4">
            <div class="card-body">
              <ngx-simplebar style="max-height: 360px;">
                <h5 class="card-title mb-0">Comments :</h5>
                <ul class="media-list list-unstyled mb-0">
                  <li class="mt-4" *ngFor="let com of mainVideo.comments">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center">
                        <a class="pe-3" href="experiences-for-traveler/{{com.travelerId}}">
                          <img src="{{com.travelerImage?com.travelerImage:imageUrl}}" class="img-fluid avatar avatar-md-sm rounded-circle shadow"
                            alt="img">
                        </a>
                        <div class="commentor-detail">
                          <h6 class="mb-0"><a href="experiences-for-traveler/{{com.travelerId}}" class="text-dark media-heading">{{com.travelerName}}</a>
                          </h6>
                          <small class="text-muted">{{com.date|date:'dd/MM/yyyy hh:MM'}}</small>
                        </div>
                      </div>
                      <!-- <a [ngxScrollTo]="'#home'" class="text-muted"><i class="mdi mdi-reply"></i> Reply</a> -->
                    </div>
                    <div class="mt-3">
                      <p class="text-muted fst-italic p-3 bg-light rounded">{{com.comment}}</p>
                    </div>
                  </li>
    
                </ul>
              </ngx-simplebar>
            </div>
          </div>
  
          <div class="card shadow rounded border-0 mt-4">
            <div class="card-body">
              <h5 class="card-title mb-0">Leave A Comment :</h5>
  
              <form class="mt-3">
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">Your Comment</label>
                      <div class="form-icon position-relative">
                        <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                        <textarea id="message" placeholder="Your Comment" [(ngModel)]="myComment" rows="5" name="message"
                          class="form-control ps-5" required=""></textarea>
                      </div>
                    </div>
                  </div>
                  <!--end col-->
  
          
                  <!--end col-->
  
             
                  <!--end col-->
  
                  <div class="col-md-12">
                    <div class="send d-grid">
                      <button type="submit" [disabled]="myComment==''" (click)="comment()" class="btn btn-primary">Comment</button>
                    </div>
                  </div>
                  <!--end col-->
                </div>
                <!--end row-->
              </form>
              <!--end form-->
            </div>
          </div>
  
        </div>
        <!-- BLog End -->
  
        <!-- START SIDEBAR -->
        <div class="col-lg-4 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
          <div class="card border-0 sidebar sticky-bar ms-lg-4">
              <div class="card-body p-0">
                  <!-- Author -->
                  <div class="text-center">
                    <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#login-popup"  class="btn btn-primary m-1"> Add Experience</a>

                      <!-- <div class="mt-4">
                          <img src="{{mainVideo.travelerImage?mainVideo.travelerImage:imageUrl}}" class="img-fluid avatar avatar-medium rounded-pill shadow-md d-block mx-auto" alt="">
                                        
                          <a routerLink="/blog-about" class="text-primary h5 mt-4 mb-0 d-block"> {{mainVideo.travelerName}} </a>
                      </div> -->
                  </div>
                  <!-- Author -->
  
                  <!-- RECENT POST -->
                  <div class="widget mt-4">
                 
  
                      <div class="mt-4">
                          <div class="d-flex align-items-center" *ngFor="let item of experiences" (click)="playMainVideo(item)">
                            <video class="videoCard" width="50%"  (click)="playMainVideo(item)" style="margin-bottom: 20px;">
                              <source [src]="item.videoUrl" type="video/mp4">
                                </video>
                            <!-- <div (click)="playMainVideo(item)" [innerHtml]="item.embedServiceHtml"></div> -->
                            <div class="flex-1 ms-3">
                                  <a href="javascript:void(0)" (click)="playMainVideo(item)" class="d-block title text-dark">{{item.title}}</a>
                                  <span class="text-muted">{{item.date|date:'MMM d, y'}}</span>
                              </div>
                          </div>
                          <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" aria-label="Custom pagination" [pageSize]="pageSize" (pageChange)="getPremiumData();">
                            <ng-template ngbPaginationPrevious>Prev</ng-template>
                            <ng-template ngbPaginationNext>Next</ng-template>
                        </ngb-pagination>
                      </div>
                  </div>
                 
              
                  <!-- SOCIAL -->
              </div>
          </div>
      </div><!--end col-->
        <!-- END SIDEBAR -->
      </div>
      <!--end row-->
    </div>
    <!--end container-->
  </section>

  <!--end section-->
  <!-- Blog End -->
  
  <!-- Back to top -->
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>

  <!-- Back to top -->


  <div class="modal fade"  #modal id="login-popup" tabindex="-1" aria-hidden="false">
    <div class="modal-dialog  modal-lg modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
      
          <div class="modal-body p-0">
                <div class="container-fluid px-0">
                    <div class="row align-items-center g-0">
                        <div class="col-lg-6 col-md-5">
                            <!-- <img src="assets/images/course/online/ab02.jpg" class="img-fluid" alt=""> -->
                <upload-video *ngIf="!uploadedVideo" (onUploadFinished)="onUploadFinished($event)"></upload-video>
                     <div *ngIf="uploadedVideo"> 
                      <!-- <div  class="videoCard" [innerHtml]="videoUploadedurl"></div>
                       -->
                       <video  controls width="100%" height="100%">
                        <source src="{{videoUploadedurl}}" type="video/webm" />
                      
                        <source src="{{videoUploadedurl}}" type="video/mp4" />
                      
                      </video>
                    </div> 
                          </div><!--end col-->

                        <div class="col-lg-6 col-md-7">
                            <form class="login-form p-4" [formGroup]="addForm">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <label class="form-label">Title <span class="text-danger">*</span></label>
                                            <div class="form-icon position-relative">
                                                <!-- <i-feather name="user" class="fea icon-sm icons"></i-feather> -->
                                                <input type="email" class="form-control ps-5" formControlName="title" placeholder="Title" name="email" required="">
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                    <div class="col-lg-12">
                                        <div class="mb-3">
                                            <label class="form-label">Description</label>
                                            <div class="form-icon position-relative">
                                                <!-- <i-feather name="key" class="fea icon-sm icons"></i-feather> -->
                                                <textarea type="text" class="form-control ps-5" formControlName="description" placeholder="Description" required=""></textarea>
                                            </div>
                                        </div>
                                    </div><!--end col-->

                                

                                    <div class="col-lg-12 mb-0">
                                        <div class="d-grid">
                                            <button class="btn btn-primary" (click)="saveExperience()">Save</button>
                                        </div>
                                    </div><!--end col-->

                                </div><!--end row-->
                            </form>
                        </div><!--end col-->
                    </div><!--end row-->
                </div><!--end container-->
            </div>
        </div>
    </div>
</div>
